module.exports = __webpack_public_path__ + "img/approve.b58ab770.svg";